import React from 'react';
import '../styles/policy.css';

const ContactSubmitted = ({onClose, message, success}) => {
    const iconToShow = success ? (
        <svg viewBox="0 0 24 24" width="48" height="48">
            <path
                fill="currentColor"
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            />
        </svg>
    ) : (
        <svg viewBox="0 0 24 24" width="48" height="48">
            <path
                fill="currentColor"
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
            />
        </svg>
    );
    return (
        <div className="modal">
            <div className="modal-content policy-section">
                <span className="close" onClick={onClose}>&times;</span>
                <div className="form-success">
                    <div className="success-icon">
                        {iconToShow}
                    </div>
                    <h3>Thank you for reaching out!</h3>
                    <p>{message}</p>
                    <button
                        className="primary-button"
                        onClick={onClose}
                    >
                        Send Another Message
                    </button>
                </div>

            </div>
        </div>
    );
};

export default ContactSubmitted;